import { useState } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ProblemSection from "../components/ProblemSection";
import DoctorSection from "../components/DoctorSection";
import TreatmentSection from "../components/TreatmentSection";
import WhyChooseSection from "../components/WhyChooseSection";
import ResultsSection from "../components/ResultsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import LocationSection from "../components/LocationSection";
import FAQSection from "../components/FAQSection";
import BookingSection from "../components/BookingSection";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

const LandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-stone-50" data-testid="landing-page">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <main>
        <HeroSection />
        <ProblemSection />
        <DoctorSection />
        <TreatmentSection />
        <WhyChooseSection />
        <ResultsSection />
        <TestimonialsSection />
        <LocationSection />
        <FAQSection />
        <BookingSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default LandingPage;
